import { render, staticRenderFns } from "./InternalReviewModal.vue?vue&type=template&id=aaf9852a"
import script from "./InternalReviewModal.vue?vue&type=script&lang=js"
export * from "./InternalReviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports